module.exports = __webpack_public_path__ + "img/applyboxtop.8cf3cf16.png";